<template>
<v-card>
  <v-list three-line class="py-0">
    <v-list-tile avatar @click="$emit('click',item)">
      <v-list-tile-avatar>
        <v-progress-circular indeterminate color="orange" v-if="item.name=='0'"></v-progress-circular>
        <v-icon color="green" v-else>cloud_done</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>{{ localeDateString(item.name) }}</v-list-tile-title>
        <v-list-tile-sub-title v-if="snapshotSummary">{{ snapshotSummary }}</v-list-tile-sub-title>
        <v-list-tile-sub-title v-else>{{ (item.result||{}).ContentLength }} {{ (item.result||{}).AcceptRanges }}</v-list-tile-sub-title>
        <v-list-tile-sub-title v-if="restoreTime">{{ $t('twins.last_restore_at',{t:restoreTime}) }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
export default {
  name: 'TwinsItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    snapshotSummary() {
      if (this.item.snapshot) {
        let d = Object.keys(this.item.snapshot.device || {}).length;
        let m = Object.keys(this.item.snapshot.macro || {}).length;
        let s = Object.keys(this.item.snapshot.scene || {}).length;
        return this.$t('twins.summary', {
          device: d,
          macro: m,
          scene: s
        });
      }
    },
    restoreTime() {
      if (this.item.lastRestore) {
        return new Date(this.item.lastRestore).toLocaleString();
      }
    }
  },
  methods: {
    localeDateString(raw) {
      if (raw == undefined) return;
      if (raw == '0') return this.$t('twins.backup_processing');
      let m = raw.match(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})(\d{3})Z/);
      return new Date(`${m[1]}-${m[2]}-${m[3]}T${m[4]}:${m[5]}:${m[6]}.${m[7]}Z`).toLocaleString();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/twins/TwinsItem.vue